import { render, staticRenderFns } from "./MatchConflictsProductSelectPrincipalAccordion.vue?vue&type=template&id=30c32eae&scoped=true&"
import script from "./MatchConflictsProductSelectPrincipalAccordion.vue?vue&type=script&lang=ts&"
export * from "./MatchConflictsProductSelectPrincipalAccordion.vue?vue&type=script&lang=ts&"
import style0 from "./MatchConflictsProductSelectPrincipalAccordion.vue?vue&type=style&index=0&id=30c32eae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c32eae",
  null
  
)

export default component.exports